import React from 'react';
import Icon from '../../../components/AppIcon';

const TeamPerformanceOverview = () => {
  const performanceMetrics = [
    {
      id: 1,
      title: "Team Productivity",
      value: "87%",
      change: "+5.2%",
      trend: "up",
      icon: "TrendingUp",
      color: "text-success"
    },
    {
      id: 2,
      title: "Task Completion Rate",
      value: "94%",
      change: "+2.1%",
      trend: "up",
      icon: "CheckCircle",
      color: "text-success"
    },
    {
      id: 3,
      title: "Resource Utilization",
      value: "78%",
      change: "-1.3%",
      trend: "down",
      icon: "Users",
      color: "text-warning"
    },
    {
      id: 4,
      title: "Budget Efficiency",
      value: "92%",
      change: "+3.7%",
      trend: "up",
      icon: "DollarSign",
      color: "text-success"
    }
  ];

  const recentActivities = [
    {
      id: 1,
      employee: "Kadiatou Bah",
      action: "Completed quarterly review",
      time: "2 hours ago",
      status: "completed"
    },
    {
      id: 2,
      employee: "Ibrahima Camara",
      action: "Submitted expense report",
      time: "4 hours ago",
      status: "pending"
    },
    {
      id: 3,
      employee: "Mariama Condé",
      action: "Updated project milestone",
      time: "6 hours ago",
      status: "completed"
    },
    {
      id: 4,
      employee: "Sékou Keïta",
      action: "Requested time off",
      time: "1 day ago",
      status: "pending"
    }
  ];

  return (
    <div className="space-y-6">
      {/* Performance Metrics Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {performanceMetrics?.map((metric) => (
          <div key={metric?.id} className="bg-card border border-border rounded-lg p-6 card-shadow">
            <div className="flex items-center justify-between mb-4">
              <div className={`p-2 rounded-lg bg-muted ${metric?.color}`}>
                <Icon name={metric?.icon} size={20} />
              </div>
              <div className={`flex items-center text-sm ${
                metric?.trend === 'up' ? 'text-success' : 'text-warning'
              }`}>
                <Icon 
                  name={metric?.trend === 'up' ? 'ArrowUp' : 'ArrowDown'} 
                  size={16} 
                  className="mr-1" 
                />
                {metric?.change}
              </div>
            </div>
            <div className="space-y-1">
              <h3 className="text-2xl font-semibold text-foreground">{metric?.value}</h3>
              <p className="text-sm text-muted-foreground">{metric?.title}</p>
            </div>
          </div>
        ))}
      </div>
      {/* Recent Team Activities */}
      <div className="bg-card border border-border rounded-lg p-6 card-shadow">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-lg font-semibold text-foreground">Recent Team Activities</h3>
          <button className="text-sm text-primary hover:text-primary/80 transition-smooth">
            View All
          </button>
        </div>
        
        <div className="space-y-4">
          {recentActivities?.map((activity) => (
            <div key={activity?.id} className="flex items-center justify-between p-4 bg-muted/50 rounded-lg">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
                  <Icon name="User" size={16} color="white" />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground">{activity?.employee}</p>
                  <p className="text-xs text-muted-foreground">{activity?.action}</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <span className="text-xs text-muted-foreground">{activity?.time}</span>
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                  activity?.status === 'completed' 
                    ? 'bg-success/10 text-success' :'bg-warning/10 text-warning'
                }`}>
                  {activity?.status}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TeamPerformanceOverview;